// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1___29bfb68a6e24f180d7b","cls2":"SmallAccountMenuButton-cls2___ccac9b7e6a3ab8c3941 SmallAccountMenuButton-cls1___29bfb68a6e24f180d7b"};